import Api from '../api';
const { axios: api } = Api;

const PREFIX = 'file';

export const getFile = async (payload) => {
	const data = await api.get(`/${PREFIX}/${payload}?base64=true`);

	return { data: data?.data };
};

export const getPublicFileBlob = async (fileId) => {
	const { data } = await api.get(`/${PREFIX}/public/${fileId}`, {
		responseType: 'blob',
	});

	return data;
};

const normalizeBlobContentType = (blob, headerType = '', expectedMediaType = null) => {
	const normalizedHeader = headerType.split(';')[0]?.trim() || '';

	if (normalizedHeader && normalizedHeader !== 'application/octet-stream') {
		return normalizedHeader;
	}

	if (blob?.type && blob.type !== 'application/octet-stream') {
		return blob.type;
	}

	if (expectedMediaType === 'video') {
		return 'video/mp4';
	}

	if (expectedMediaType === 'image') {
		return 'image/jpeg';
	}

	return blob?.type || 'application/octet-stream';
};

const sniffVideoContentType = async (blob) => {
	try {
		const buffer = await blob.slice(0, 64).arrayBuffer();
		const bytes = new Uint8Array(buffer);

		if (
			bytes.length >= 4
			&& bytes[0] === 0x1a
			&& bytes[1] === 0x45
			&& bytes[2] === 0xdf
			&& bytes[3] === 0xa3
		) {
			return 'video/webm';
		}

		for (let index = 0; index <= bytes.length - 4; index += 1) {
			if (
				bytes[index] === 0x66
				&& bytes[index + 1] === 0x74
				&& bytes[index + 2] === 0x79
				&& bytes[index + 3] === 0x70
			) {
				return 'video/mp4';
			}
		}
	} catch {
		return null;
	}

	return null;
};

export const getFileBlobUrl = async (fileId, expectedMediaType = null) => {
	const response = await api.get(`/${PREFIX}/${fileId}`, {
		responseType: 'blob',
	});

	const blobData = response.data;
	let contentType = normalizeBlobContentType(
		blobData,
		response.headers?.['content-type'] || '',
		expectedMediaType,
	);

	if (expectedMediaType === 'video') {
		const sniffedType = await sniffVideoContentType(blobData);

		if (sniffedType) {
			contentType = sniffedType;
		}
	}

	const blob =
		blobData?.type === contentType
			? blobData
			: new Blob([blobData], { type: contentType });
	const url = URL.createObjectURL(blob);

	return { url, contentType };
};
